import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-link',
  templateUrl: './share-link.component.html',
  styleUrls: ['./share-link.component.less']
})
export class ShareLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/share-map/share-link/share-link.component.ts